"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../../core/utils");
var _default = exports["default"] = function _default(reduxStore, exceptionUri, handlers) {
  if (!Array.isArray(handlers)) {
    _utils.console.consoleError('onEnterAggregateRouteHandler. Wrongs arguments: argument should be an array of functions!', handlers);
  }
  return function (nextState, replace, callback) {
    _utils.console.consoleGroup("onEnterAggregateRouteHandler started. Location: ".concat(nextState.location.pathname));
    _utils.console.consoleLog('nextState', nextState);

    // 1) promiseFactory returns another function that return a promise.
    // 2) Factory will be pass to `then`.
    // 3) `then` always should receive function that can return some result.
    // (or do throw new Error, or return undefined).
    // 4) In this case, promise is result.
    // 5) Result of promise will be pass to next `then`.

    // If you can't understand this code you should know about promises better.
    // see "Advanced mistake #3: promises vs promise factories"
    // http://pouchdb.com/2015/05/18/we-have-a-problem-with-promises.html
    // https://habrahabr.ru/company/mailru/blog/269465/
    var promiseFactory = function promiseFactory(handler) {
      return function () {
        return new Promise(function (resolve, reject) {
          var func = handler(reduxStore);
          _utils.console.consoleLog("".concat(func.name, " started."));
          func(nextState, resolve, reject);
        });
      };
    };
    var result = Promise.resolve();
    handlers.forEach(function (handler) {
      result = result.then(promiseFactory(handler));
    });
    result.then(function () {
      _utils.console.consoleLog('onEnterAggregateRouteHandler success.');
      _utils.console.consoleGroupEnd();
      callback();
    }, function (replaceTo) {
      _utils.console.consoleError('onEnterAggregateRouteHandler rejected. Redirect to:', replaceTo);
      _utils.console.consoleGroupEnd();
      replace(replaceTo);
      // callback();
    })["catch"](function (error) {
      _utils.console.consoleError('onEnterAggregateRouteHandler failed', error);
      _utils.console.consoleGroupEnd();
      replace(exceptionUri);
      // callback();
    });
  };
};